<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget"
         id="categories-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Kategorie produktů</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterCategories($event)"></swb-filter-list>
          <a [routerLink]="['categories/add']"
             class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> kategorii
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-product-category-list [query]="categoriesQuery"></swb-product-category-list>
      </div>
    </div>
  </div>
  <div class="widget__wrap">
    <div class="widget"
         id="products-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Produkty</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterProducts($event)"></swb-filter-list>
          <a [routerLink]="['products/add']"
             class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> produkt
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-product-list [query]="productsQuery"></swb-product-list>
      </div>
    </div>
  </div>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag"
     [dragula]='"widget-bag"'>
  <div class="widget__wrap">
    <div class="widget"
         id="categories-widget">
      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Reference</span>
        <span class="widget__header__tools">
          <swb-filter-list (modelChange)="filterTestimonials($event)"></swb-filter-list>
          <a [routerLink]="['testimonials/add']"
             class="cta cta--small cta--green">
            <span class="cta__light">Přidat</span> referenci
            <i class="ico-plus"></i>
          </a>
        </span>
      </h2>
      <div class="widget__content">
        <swb-testimonial-list [query]="testimonialsQuery"></swb-testimonial-list>
      </div>
    </div>
  </div>
  <swb-testimonial-settings></swb-testimonial-settings>
</div>